import { Select, SelectOption, Ref } from "@tblabs/truffle";


export class CustomerExperienceSelector extends Select<number>
{
    constructor(exp?: Ref<number>)
    {
        const experienceOptions = [
            new SelectOption("Nie wybrano", 0),
            new SelectOption("🥔 Atechniczny", 1),
            new SelectOption("🥉 Nigdy nie korzystał", 2),
            new SelectOption("🥈 Korzystał z podobnego", 3),
            new SelectOption("🥇 Używał naszego", 4),
        ];

        super(exp, experienceOptions);
    }
}
